// Safe localStorage wrapper for Safari/iOS compatibility
// Safari in private mode and some iOS scenarios throw on localStorage access

const memoryFallback = {};

function isAvailable() {
  try {
    const key = "__gfp_storage_test__";
    localStorage.setItem(key, "1");
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

const storageAvailable = isAvailable();

export function safeGet(key) {
  try {
    if (storageAvailable) return localStorage.getItem(key);
    return memoryFallback[key] ?? null;
  } catch {
    return memoryFallback[key] ?? null;
  }
}

export function safeSet(key, value) {
  try {
    if (storageAvailable) {
      localStorage.setItem(key, value);
    } else {
      memoryFallback[key] = value;
    }
  } catch {
    memoryFallback[key] = value;
  }
}

export function safeRemove(key) {
  try {
    if (storageAvailable) localStorage.removeItem(key);
    delete memoryFallback[key];
  } catch {
    delete memoryFallback[key];
  }
}

export function safeGetJSON(key) {
  try {
    const raw = safeGet(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function safeSetJSON(key, value) {
  try {
    safeSet(key, JSON.stringify(value));
  } catch (e) { console.warn("safeSetJSON failed:", e); }
}

export const storageWorks = storageAvailable;
